import { ViewMode } from '../constants';
import { get, post, put, remove as httpRemove } from '../Services/http';
import { catchError } from './Error.action';
import {
    FETCH_BUDGET,
    UPDATE_BUDGET,
    VALIDATE_CHECKOUT,
    GET_WORKEAR_MENU_LINK
} from '../constants';
import { receive } from './Cart.action';
import { useSelector,useDispatch } from 'react-redux';

const API_URL = '/api/budget'
const API_URL_LINK_AND_TEXT = '/api/workWear'
let isWorkWearCustomer = "";

export const checkWorkWearCustomer = () => (dispatch) => {
  if(window.__litium.preloadState.myPage.isBusinessCustomer){
      return get(`${API_URL}/isWorkWearCustomer`)
      .then((response) => response.json())
      .then((result) => {
        isWorkWearCustomer = result.isWorkWearCustomer

          dispatch(validateWorkWearCustomer(result))
      })
      .catch((ex) => { console.log('error', ex) })
  }
}

export const fetchBudget = () => (dispatch) => {
  if(window.__litium.preloadState.myPage.isBusinessCustomer && isWorkWearCustomer ){
    return get(`${API_URL}/getBudget`)
    .then((response) => response.json())
    .then((result) => {
        dispatch(receiveBudget(result))
    })
    .catch((ex) => { console.log('error', ex) })
  }

}

export const validateCheckout = (totalSum) => (dispatch) => {  
    return fetch(`${API_URL}/validateCheckout?checkoutSum=${totalSum}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((result) => {
        dispatch(receiveValidateCheckout(result));
      })
      .catch((error) => {
        console.error('Error fetching store sign templates:', error);
      });
  };


export const checkWorkWearlinkAndText = () => (dispatch) => {
  if(window.__litium.preloadState.myPage.isBusinessCustomer && isWorkWearCustomer){
    return get(`${API_URL_LINK_AND_TEXT}/getWorkWearLink`)
    .then((response) => response.json())
    .then((result) => {
      dispatch(reciveUrlLinkAndText(result))
    })
    .catch((ex) => {console.log('error', ex)})
  }
}

const reciveUrlLinkAndText = (getWorkWearLink) => ({
  type: GET_WORKEAR_MENU_LINK,
    payload:{
      getWorkWearLink,
    }
})

const receiveBudget = (budget) => ({
    type:  FETCH_BUDGET,
    payload: {
       budget,
    },
});


const receiveValidateCheckout = ( validateCheckout) => ({
    type: VALIDATE_CHECKOUT,
    payload: {
       validateCheckout,
    },
});

const validateWorkWearCustomer = (validateWorkWear) => ({
  type:  FETCH_BUDGET,
  payload: {
    validateWorkWear,
  },
});